import { withOnFirstSubscription } from '@ardoq/common-helpers';
import { ViewpointBuilderTab } from 'viewpointBuilder/viewpointBuilderNavigation/types';
import {
  InitialViewpointBuilderConfiguration,
  ViewpointBuilderCommands,
  ViewpointBuilderContext,
  ViewpointBuilderViewState,
} from 'viewpointBuilder/types';
import { dispatchAction, type Routine } from '@ardoq/rxbeach';
import { requestLoadMetaModel } from 'architectureModel/actions';
import { initViewpointBuilder } from '../initViewpointBuilder';
import {
  combineViewpointBuilderStreams,
  ViewpointBuilderStreams,
} from './viewpointBuilder$';
import { Observable } from 'rxjs';

export type GetViewpointBuilderStreamArgs = {
  streams: ViewpointBuilderStreams;
  activeTab: ViewpointBuilderTab;
  context: ViewpointBuilderContext;
  initialConfiguration: InitialViewpointBuilderConfiguration | undefined;
  viewpointBuilderCommands: ViewpointBuilderCommands;
  folderId?: string | null;
  getAdditionalRoutines?: (
    viewpointBuilderStream: Observable<ViewpointBuilderViewState>
  ) => Routine<unknown>[];
};

export const getViewpointBuilderStream = ({
  onFirstSubscriptionCallback,
  ...getViewpointBuilderStreamArgs
}: GetViewpointBuilderStreamArgs & {
  onFirstSubscriptionCallback?: () => void;
}) =>
  withOnFirstSubscription(
    combineViewpointBuilderStreams(getViewpointBuilderStreamArgs.streams),
    onFirstSubscriptionCallback ??
      getDefaultOnFirstSubscriptionCallback(getViewpointBuilderStreamArgs)
  );

const getDefaultOnFirstSubscriptionCallback =
  ({
    streams,
    activeTab,
    context,
    initialConfiguration,
    folderId,
    viewpointBuilderCommands,
  }: GetViewpointBuilderStreamArgs) =>
  () => {
    dispatchAction(requestLoadMetaModel());

    initViewpointBuilder({
      namespace: streams.namespace,
      activeTab,
      context,
      initialConfiguration,
      folderId,
      viewpointBuilderCommands,
    });
  };
